import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as styles from './cancelButton.css';

import { Button } from '@cian/button-component';

export interface ICancelButtonProps {
  entityId: number;
  onClick(): void;
}

export class CancelButton extends React.PureComponent<ICancelButtonProps> {
  public render() {
    const { onClick } = this.props;

    return (
      <div>
        <Button size="S" type="button" theme="ghost" {...mergeStyles(styles.red_color)} onClick={onClick}>
          Отмена
        </Button>
      </div>
    );
  }
}
